import { AfterViewInit, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { MemberAuthViewModel } from '../member-auth-view-model';
import { VerifyMemberRequest } from '../../../../../../models/users/requests/verify-member-request';
import { StringExtensions } from '../../../../../../utils/string.extensions';
import { AssetSize } from '../../../../../../models/enum/dto/asset-size.enum';
import { ButtonTypeEnum } from '../../../../../../ui/buttons/button/button-type.enum';
import { DateInputComponent } from '../../../../../../ui/form-components/date-input/date-input.component';

@Component({
  selector: 'app-member-welcome',
  templateUrl: './member-welcome.component.html',
  styleUrls: ['./member-welcome.component.scss', '../../auth.component.scss']
})
export class MemberWelcomeComponent implements AfterViewInit {
  private viewModel = inject(MemberAuthViewModel);

  @ViewChild('dateInput', { static: true }) dateInput!: DateInputComponent;

  public authFlowTitle$ = this.viewModel.authFlowTitle$;
  public authFlowSubtext$ = this.viewModel.authFlowSubtext$;
  public verifyMemberFailed$ = this.viewModel.verifyMemberFailed$;

  public formSubmitted = false;

  public formGroup = new FormGroup({
    birthdate: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    sin: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(11)]
    })
  });

  private clearFailedStateOnEdit = this.formGroup.valueChanges
    .pipe(takeUntilDestroyed())
    .subscribe(() => this.viewModel.clearVerifyMemberFailed());

  private clearFailedStateOnDestroy = inject(DestroyRef).onDestroy(() => this.viewModel.clearVerifyMemberFailed());

  public sinMaskOptions: MaskitoOptions = {
    mask: ['-', '-', '-', ' ', '-', '-', '-', ' ', /\d/, /\d/, /\d/]
  };

  public customErrorMessages = {
    birthdate: {
      required: $localize`Date of birth is required`
    },
    sin: {
      required: $localize`Last 3 digits of your SIN are required`,
      minlength: $localize`Last 3 digits of your SIN are required`
    }
  };

  public ngAfterViewInit(): void {
    this.dateInput.input.nativeElement.focus();
  }

  public verifyMember(): void {
    this.formSubmitted = true;
    if (!this.formGroup.valid) return;
    const { birthdate, sin } = this.formGroup.getRawValue();
    const req = new VerifyMemberRequest(
      StringExtensions.removeDashesFromSin(sin),
      StringExtensions.convertDateFormatForBackend(birthdate)
    );
    this.viewModel.verifyMember(req);
  }

  public openContactPage(): void {
    this.viewModel.openContactPage();
  }

  protected readonly AssetSize = AssetSize;
  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
